import { useNavigate } from 'react-router'
import { useGame } from '../GameContext'
import { RULES } from '../constants'
import { Button, WashiTape } from '../components/ui'
import { BookOpen, Play } from 'lucide-react'

function RuleRow({ index, rule, badgeClassName = '' }) {
  return (
    <div className="flex gap-3">
      <span
        className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-base font-hand ${badgeClassName}`}
      >
        {index + 1}
      </span>
      <p className="text-sm pt-1">{rule}</p>
    </div>
  )
}

export default function Rules() {
  const navigate = useNavigate()
  const { gameState } = useGame()
  const hasStarted = gameState.holes.some((h) => h.scores.some((s) => s.strokes > 0))

  return (
    <div className="min-h-screen flex flex-col py-6">
      <div className="flex-1 max-w-md w-full mx-auto space-y-6">
        <div className="space-y-6 relative">
          <div className="relative text-center">
            <WashiTape className="left-1/2 -translate-x-1/2 -top-3" rotation="-3deg" />
            <h2 className="text-2xl font-hand relative z-10">Spelregels</h2>
          </div>

          <div className="rounded-lg border border-border/60 bg-card shadow-paper-sm overflow-hidden">
            <div className="torn-edge h-2" />
            <div className="px-4 py-3 space-y-2.5 relative">
              {RULES.map((rule, index) => (
                <div
                  key={index}
                  className="border-b border-dotted border-border/50 last:border-0 pb-2.5 last:pb-0"
                >
                  <RuleRow index={index} rule={rule} badgeClassName="border border-primary/30 text-primary" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <Button onClick={() => navigate('/play')} className="w-full" size="lg">
          {hasStarted ? (
            <>
              <BookOpen className="mr-2 h-5 w-5" />
              Verder spelen
            </>
          ) : (
            <>
              <Play className="mr-2 h-5 w-5" />
              Beginnen met spelen
            </>
          )}
        </Button>
      </div>
    </div>
  )
}